import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import HotVideos from './components/HotVideos';
import LatestArticles from './components/LatestArticles';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '白云视频',
  url: 'https://baiyunvideo.com',
  description: '白云视频-苹果视频与榴莲视频同类手机免费在线播放 | 看视频app高清不缓冲',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://baiyunvideo.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webpageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '白云视频 - 苹果视频与榴莲视频同类手机免费在线播放',
  description: '白云视频提供苹果视频、榴莲视频同款手机看片体验，免费影视app在线视频平台，随时随地高清视频播放。',
  url: 'https://baiyunvideo.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '白云视频',
    url: 'https://baiyunvideo.com',
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageJsonLd)}</script>
      <Navbar />
      <main>
        <Hero />
        <CategoryNav />
        <HotVideos />
        <LatestArticles />
      </main>
      <Footer />
    </>
  );
}